
import React, { useEffect, useState } from 'react';
import Breadcrumbs, { BreadcrumbsItem } from '../../../../template/MainTheme/components/Breadcrumbs';
import { Tabs, Tab } from 'react-bootstrap';
import QuoteTab from '../tabs/QuoteTab';
import WarehouseStorageContainer from '../../subpages/WareHouseQuote/components/containers/WareHouseStorageContainer';
import WarehouseQuoteExpeditionContainer from '../../subpages/WareHouseQuote/components/containers/WareHouseExpeditionContainer';
import WarehouseQuoteRatesContainer from '../../subpages/WareHouseQuote/components/containers/WareHouseRatesContainer';
import WarehouseQuoteExtraServiceContainer from '../../subpages/WareHouseQuote/components/containers/WareHouseExtraServicesContainer';
import WarehouseQuoteDetailsContainer from '../../subpages/WareHouseQuote/components/containers/WareHouseQuoteDetailContainer';

import { QuoteShowDataForm } from '../../../../app/models/Quote';
import { WarehouseQuoteStorageDataForm } from '../../../../app/models/WareHouseQuoteStorage';
import { WarehouseExpeditionDataForm } from '../../../../app/models/WareHouseQuoteExpedition';
import WarehouseQuoteHistoryContainer from '../../subpages/WareHouseQuote/components/containers/WareHouseHistoryContainer';
import useQuoteInvoicingService from '../../../../app/services/hooks/useQuoteInvoicingService';
import { QuoteInvoicingShowDataForm } from '../../../../app/models/QuoteInvoicing';
import { ServiceResponse } from '../../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import DefaultCard from '../../../../components/default/DefaultCard';
import QuoteInvoicingShowForm from '../forms/QuoteInvoicingShowForm';
import LazyLoading from '../../../../components/LazyLoading';

interface Props {
    id: number;
    quoteForm: QuoteShowDataForm;
    sectorId: number;
    // storages: WarehouseQuoteStorageDataForm;
    // expeditions: WarehouseExpeditionDataForm;
    disableUpdate: boolean;
}

const WareHouseQuoteShowContainer = ({
    id,
    quoteForm,
    sectorId,
    // storages,
    // expeditions,
    disableUpdate
}: Props) => {

    
    useEffect(() => {
        // show(id);
        reloadQuoteInvoicing(id)
    }, [id]);
    const { 
        getQuoteInvoicingByQuote,
        updateQuoteInvoicing, 
        fetchingQuoteInvoicingByQuote,
        fetchingUpdateQuoteInvoicing
    } = useQuoteInvoicingService();
    
    const [quoteInvoicingForm, setQuoteInvoicingForm] = useState<QuoteInvoicingShowDataForm>({});
    
    const reloadQuoteInvoicing = (id: number) => {
    
        if (id) {
            getQuoteInvoicingByQuote(Number(id),'view', {
                onSuccess: (response: ServiceResponse) => {
                    setQuoteInvoicingForm(response.data.quote_invoicing);
                },
                onError: (response: ServiceResponse) => 
                    {
                    toast.info(response.message);
                }
            });
        }
    };
    const breadcrumbs: BreadcrumbsItem[] = [
        {
            name: 'Cotizaciones',
            url: '/quotes',
            isActive: false
        },
        {
            name: 'Mostrar cotización #' + id,
            url: `/quotes/${id}/show`,
            isActive: true
        }
    ];

    return (
        <>
            <Breadcrumbs pageSection={`Mostrar cotización WAREHOUSE #${id}`} breadcrumbs={breadcrumbs} />
            <Tabs defaultActiveKey="general-data" id="quote-tabs" className="mb-3">
                <Tab eventKey="general-data" title="Datos Generales">
                    <QuoteTab
                        quoteShowForm={quoteForm}
                        fetchingQuote={false}
                        isFormShow={true}
                    />
                </Tab>
{/* 
                <Tab eventKey="interlocutors" title="Interlocutores" disabled />
                <Tab eventKey="management" title="Gestión" disabled /> */}
                <Tab eventKey="storage" title="Almacenamiento">
                    <WarehouseStorageContainer quoteId={id} disableUpdate={true} isFormShow={true}  />
                </Tab>

                <Tab eventKey="expedition" title="Expedición">
                    <WarehouseQuoteExpeditionContainer quoteId={id} disableUpdate={true} isFormShow={true} />
                </Tab>


                <Tab eventKey="extras" title="Servicios Adicionales">
                    <WarehouseQuoteExtraServiceContainer quoteId={id} disableUpdate={true} isFormShow={true} />
                </Tab>
                <Tab eventKey="invoicing" title="Facturación">
                    <DefaultCard>
                        <div className="h3 mt-0 mb-2 card-title">Facturación</div>
                        {!fetchingQuoteInvoicingByQuote ? (
                            <>
                                <QuoteInvoicingShowForm
                                    quoteInvoicingForm={quoteInvoicingForm}
                                />
                            </>
                        ) : (
                            <LazyLoading />
                        )}
                    </DefaultCard>
                </Tab>
                <Tab eventKey="rates" title="Tarifas del servicio">
                    <WarehouseQuoteRatesContainer quoteId={id} disableUpdate={true} isFormShow={true} />
                </Tab>
                <Tab eventKey="management" title="Gestión" disabled>
                    Gestión
                </Tab>
                <Tab eventKey="history" title="Historial">
                    <WarehouseQuoteHistoryContainer quoteId={id} disableUpdate={disableUpdate}  />
                </Tab>
            </Tabs>

            <WarehouseQuoteDetailsContainer
                quoteId={id}
                sectorId={sectorId}
                // disableUpdate={disableUpdate}
                // reloadQuote={handleUpdate}
                onDetailSaved={() =>({})}
                isFormShow={true}
            />
            
        </>
    );
};

export default WareHouseQuoteShowContainer;
